import { setAttr } from 'redom';

import { displayElementAroundAnchor } from 'utilities/element-position';

const positionableSides = ['bottom', 'top'];

class OptionsPositioner {

  constructor(container, anchorElement, optionsElement) {

    this.container = container;
    this.anchorElement = anchorElement;
    this.optionsElement = optionsElement;

    this.disabled = false;
    this.scheduledFrame = 0;

    this.boundApplyScheduledPosition = this.applyScheduledPosition.bind(this);
    this.boundScheduleReposition = this.scheduleReposition.bind(this);

  }

  disable() {

    this.disabled = true;

  }

  start() {

    if (this.disabled === true) {
      return;
    }

    window.addEventListener('scroll', this.boundScheduleReposition, true);
    window.addEventListener('resize', this.boundScheduleReposition);

  }

  stop() {

    window.removeEventListener('scroll', this.boundScheduleReposition, true);
    window.removeEventListener('resize', this.boundScheduleReposition);

    this.cancelScheduledReposition();

  }

  scheduleReposition() {

    if (this.disabled === true) {
      return;
    }

    if (this.scheduledFrame !== 0) {
      return;
    }

    this.scheduledFrame = window.requestAnimationFrame(this.boundApplyScheduledPosition);

  }

  cancelScheduledReposition() {

    if (this.scheduledFrame === 0) {
      return;
    }

    window.cancelAnimationFrame(this.scheduledFrame);
    this.scheduledFrame = 0;

  }

  applyScheduledPosition() {

    this.scheduledFrame = 0;
    this.applyPosition();

  }

  applyPosition() {

    if (this.disabled === true) {
      return;
    }

    if (this.optionsElement.isConnected === false) {
      return;
    }

    if (this.optionsElement.getClientRects().length === 0) {
      return;
    }

    setAttr(this.optionsElement, {
      style: {
        width: this.anchorElement.offsetWidth + 'px',
        height: 'auto'
      }
    });

    const positionedSide = displayElementAroundAnchor(this.optionsElement, this.anchorElement, void 0, 0, 0, 'bottom', false, positionableSides);

    if (positionedSide === 'top') {
      this.container.classList.add('positioned-top');
    } else {
      this.container.classList.remove('positioned-top');
    }

  }

}

export default OptionsPositioner;
